import qs from 'querystring'
import $ from 'jquery'
import { get_errors, alert_error, post_json,
         get_myinfo, has_user_loggedin } from '../common'
import delay from 'delay'

$(init)

async function init () {
  let $page = $('#didlogin-page')
  if ($page.length == 0) {
    return
  }
  try {
    // at didlogin
    let query = qs.parse((location.search||'').substr(1))
    let isregister = 'register' in query
    if (query.error) {
      let errors = await get_errors()
      let error = (query.error in errors.bycode ? errors.bycode[query.error] :
                   { message: query.error, code: -1 })
      $('.loading-indicator').addClass('d-none')
      let $error_wrps = $('.when-error-' + (isregister ? 'register' : 'login'))
      $error_wrps.removeClass('d-none')
      $error_wrps.find('.error-msg').text(error.message)
      $error_wrps.find('.try-again-btn').on('click', ($evt) => {
        $evt.preventDefault()
        $(document).trigger('x-show-' + (isregister ? 'register' : 'login') + '-modal')
      })
    } else {
      let myinfo = await get_myinfo()
      let loggedin = has_user_loggedin(myinfo)
      if (!loggedin) {
        window.location = '/'
      } else {
        $('.loading-indicator').addClass('d-none')
        let $wrps = $('.when-' + (isregister ? 'registered' : 'logged-in'))
        $wrps.removeClass('d-none')
        try {
          if (isregister) {
            gtag('event', 'sign_up')
          }
        } catch (err) {
          console.warn('GA event error: ', err)
        }
      }
      if (query.r) {
        $page.find('.when-redirecting').removeClass('d-none')
        await delay(3000)
        window.location = query.r
      }
    }
  } catch (err) {
    alert_error(err)
  }
}

